<script setup lang="ts">
    import {vehicleSpecs, vehicleTitle} from './vehicleFormat';

    defineProps<{candidates: Record<string, any>[]; disabled: boolean}>();

    const emit = defineEmits<{(event: 'select', candidate: Record<string, any>): void}>();

    function title(candidate: Record<string, any>): string {
        return vehicleTitle(candidate, 'Voertuig');
    }

    function specs(candidate: Record<string, any>): string {
        return vehicleSpecs(candidate);
    }
</script>

<template>
    <div class="vehicle-candidates">
        <button
            v-for="candidate in candidates"
            :key="candidate.id"
            type="button"
            class="panel panel-default candidate"
            :disabled="disabled"
            @click="emit('select', candidate)">
            <img
                v-if="candidate.image"
                :src="candidate.image"
                :alt="candidate.carBrandName"
                class="candidate__image" />
            <div class="candidate__info">
                <div class="candidate__title">{{ title(candidate) }}</div>
                <div
                    v-if="specs(candidate)"
                    class="candidate__specs text-muted">
                    {{ specs(candidate) }}
                </div>
            </div>
        </button>
    </div>
</template>

<style scoped lang="scss">
    @import '../../../sass/globals';
    .vehicle-candidates {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 8px;
    }

    .candidate {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 10px;
        text-align: left;
        cursor: pointer;
        background: #fff;
    }

    .candidate:disabled {
        cursor: default;
        opacity: 0.6;
    }

    .candidate:not(:disabled):hover {
        border-color: #000;
    }

    /* A fixed 40px logo next to a card whose own width changes (2-up vs. 1-up mobile) doesn't
       scale with it - a percentage flex-basis does, capped so it can't grow past a sensible
       size on a wide card. aspect-ratio keeps it square at any resulting size. */
    .candidate__image {
        flex: 0 0 15%;
        max-width: 48px;
        aspect-ratio: 1;
        object-fit: contain;
    }

    .candidate__info {
        min-width: 0;
    }

    .candidate__title {
        font-size: 13px;
        font-weight: 700;
        line-height: 1.3;
    }

    .candidate__specs {
        margin-top: 2px;
        font-size: 12px;
        line-height: 1.3;
    }

    @media (max-width: $chat-mobile) {
        .vehicle-candidates {
            grid-template-columns: 1fr;
        }
    }
</style>
